import src from "IMAGE";
export default { src, width: 768, height: 329, blurWidth: 0, blurHeight: 0};
